module.exports = __webpack_public_path__ + "media/AlignAnalysis.044dfb9f.mp4";